"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = void 0;
var Pagination_1 = require("./Pagination");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return __importDefault(Pagination_1).default; } });
//# sourceMappingURL=index.js.map